<template>
  <div id="home">
    <Banner />
    <Categories />
  </div>
</template>

<script>
import Banner from "@/components/home/Banner.vue";
import Categories from "@/components/home/Categories.vue";

export default {
  name: "Home",
  created() {
    document.title = "Vtsv";
  },
  components: {
    Banner,
    Categories
  },
};
</script>
